import { StyleSheet, css } from "aphrodite"
import globalCSS from '../commonCss/commonCss'
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useContext } from "react";
import { NavContext } from "./navbar.component";
import { FaUserCircle } from "react-icons/fa";
import commonCss from "../commonCss/commonCss";
import { Dropdown, MenuProps } from "antd";
import { useLoginHook } from "../hooks/useLoginHook";
import { MdOutlineLogout } from "react-icons/md";
import { selectAuthUser, selectIsAuthenticated } from "../store/sessionSelectors";



const NavProfileView = () => {

    const authState = useSelector(selectAuthUser);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const navigate = useNavigate();
    const { handleLogout } = useLoginHook({ shouldLogout: false });

    const items: MenuProps['items'] = [
        {
            key: 'profile',
            label: <Link to={'/profile'}>Profile</Link>
        },
        {
            key: 'portfolio',
            label: <Link to={'/portfolio'}>Portfolio</Link>
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Log Out',
            icon: <MdOutlineLogout />,
            danger: true,
            onClick: () => handleLogout().then(() => navigate('/')),
        }
    ]

    const { handleNavAction } = useContext(NavContext);

    if (isAuthenticated) {
        return <Dropdown trigger={['click']} menu={{ items }}>
            <section className={css(globalCSS.flexRow, globalCSS.alignItemsCenter)}>
                {authState.photoURL
                    ? <img src={authState.photoURL} alt={authState.displayName + 'image'} className={css(styles.userProfileImg)} />
                    : <FaUserCircle className={css(styles.userProfileImg)}></FaUserCircle>
                }
                <div className={css(commonCss.padding10, styles.txtOvf)}> {authState.displayName} </div>
            </section>
        </Dropdown>
    } else {
        return <div className={css(globalCSS.noLinkDecoration)}>
            <Link className={css(globalCSS.noLinkDecoration, commonCss.padding10)} to="/login" onClick={() => handleNavAction()} >
                Login
            </Link>
        </div>
    }
}

const styles = StyleSheet.create({
    txtOvf: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    userProfileImg: {
        height: '20px',
        width: '20px',
        borderRadius: "100%",
    }
})

export default NavProfileView